import React from 'react';
// All SVGs use the rugby brand palette (gold + green) and share a circular badge frame
// for visual consistency. Tiny payload (< 2KB each) and render instantly — no network.
interface IconProps {
  className?: string;
}
const Frame = ({
  children
}: {
  children: React.ReactNode;
}) => <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" aria-hidden="true" data-id="element-65">
    {/* Background gradient circle */}
    <defs data-id="element-66">
      <radialGradient id="bg" cx="50%" cy="40%" r="60%" data-id="element-67">
        <stop offset="0%" stopColor="#165c3f" data-id="element-68" />
        <stop offset="100%" stopColor="#0a2e1f" data-id="element-69" />
      </radialGradient>
      <linearGradient id="gold" x1="0%" y1="0%" x2="0%" y2="100%" data-id="element-70">
        <stop offset="0%" stopColor="#fce38a" data-id="element-71" />
        <stop offset="50%" stopColor="#d4af37" data-id="element-72" />
        <stop offset="100%" stopColor="#b5952f" data-id="element-73" />
      </linearGradient>
    </defs>
    <circle cx="40" cy="40" r="38" fill="url(#bg)" stroke="#d4af37" strokeOpacity="0.4" strokeWidth="1.5" data-id="element-74" />
    {children}
  </svg>;
// B1 — Captain / Leadership: Captain's armband with C
export const CaptainIcon = () => <Frame data-id="element-75">
    <path d="M22 32 Q40 28 58 32 L58 48 Q40 52 22 48 Z" fill="url(#gold)" stroke="#0a2e1f" strokeWidth="1" data-id="element-76" />
    <text x="40" y="46" textAnchor="middle" fontSize="16" fontWeight="900" fill="#0a2e1f" fontFamily="Anton, sans-serif" data-id="element-77">
      C
    </text>
    {/* Stripes top and bottom */}
    <rect x="22" y="30" width="36" height="2" fill="#0a2e1f" opacity="0.5" data-id="element-78" />
    <rect x="22" y="48" width="36" height="2" fill="#0a2e1f" opacity="0.5" data-id="element-79" />
  </Frame>;
// B2 — Diario / Tracking: Notebook with checkmark lines
export const NotebookIcon = () => <Frame data-id="element-80">
    <rect x="26" y="22" width="28" height="36" rx="2" fill="#0a2e1f" stroke="#d4af37" strokeWidth="1.5" data-id="element-81" />
    <rect x="26" y="22" width="6" height="36" fill="#d4af37" opacity="0.3" data-id="element-82" />
    {/* Rings */}
    <circle cx="29" cy="28" r="1.2" fill="#d4af37" data-id="element-83" />
    <circle cx="29" cy="34" r="1.2" fill="#d4af37" data-id="element-84" />
    <circle cx="29" cy="40" r="1.2" fill="#d4af37" data-id="element-85" />
    <circle cx="29" cy="46" r="1.2" fill="#d4af37" data-id="element-86" />
    <circle cx="29" cy="52" r="1.2" fill="#d4af37" data-id="element-87" />
    {/* Checkmark lines */}
    <path d="M37 30 L40 33 L48 27" stroke="#fce38a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" data-id="element-88" />
    <line x1="37" y1="40" x2="50" y2="40" stroke="#d4af37" strokeWidth="1.5" strokeLinecap="round" opacity="0.7" data-id="element-89" />
    <line x1="37" y1="46" x2="50" y2="46" stroke="#d4af37" strokeWidth="1.5" strokeLinecap="round" opacity="0.7" data-id="element-90" />
    <line x1="37" y1="52" x2="46" y2="52" stroke="#d4af37" strokeWidth="1.5" strokeLinecap="round" opacity="0.7" data-id="element-91" />
  </Frame>;
// B3 — Scouting: Binoculars
export const ScoutingIcon = () => <Frame data-id="element-92">
    <circle cx="30" cy="44" r="11" fill="#0a2e1f" stroke="#d4af37" strokeWidth="2" data-id="element-93" />
    <circle cx="50" cy="44" r="11" fill="#0a2e1f" stroke="#d4af37" strokeWidth="2" data-id="element-94" />
    <circle cx="30" cy="44" r="5" fill="url(#gold)" data-id="element-95" />
    <circle cx="50" cy="44" r="5" fill="url(#gold)" data-id="element-96" />
    <rect x="38" y="40" width="4" height="8" fill="#d4af37" data-id="element-97" />
    {/* Top bridge */}
    <rect x="26" y="28" width="8" height="6" rx="1" fill="#d4af37" data-id="element-98" />
    <rect x="46" y="28" width="8" height="6" rx="1" fill="#d4af37" data-id="element-99" />
    <line x1="34" y1="31" x2="46" y2="31" stroke="#d4af37" strokeWidth="1.5" data-id="element-100" />
  </Frame>;
// B4 — Injury Free: Shield with cross
export const ShieldIcon = () => <Frame data-id="element-101">
    <path d="M40 22 L54 28 L54 42 Q54 52 40 58 Q26 52 26 42 L26 28 Z" fill="url(#gold)" stroke="#0a2e1f" strokeWidth="1.5" data-id="element-102" />
    {/* Cross */}
    <rect x="37" y="32" width="6" height="18" rx="1" fill="#0a2e1f" data-id="element-103" />
    <rect x="31" y="38" width="18" height="6" rx="1" fill="#0a2e1f" data-id="element-104" />
  </Frame>;
// B5 — Rugbier Completo: Rugby ball with star
export const RugbyBallIcon = () => <Frame data-id="element-105">
    <ellipse cx="40" cy="40" rx="20" ry="12" transform="rotate(-25 40 40)" fill="url(#gold)" stroke="#0a2e1f" strokeWidth="1.5" data-id="element-106" />
    {/* Lacing */}
    <line x1="32" y1="44" x2="48" y2="36" stroke="#0a2e1f" strokeWidth="1.2" data-id="element-107" />
    <line x1="35" y1="42" x2="38" y2="40" stroke="#0a2e1f" strokeWidth="1.2" data-id="element-108" />
    <line x1="38" y1="40.5" x2="41" y2="38.5" stroke="#0a2e1f" strokeWidth="1.2" data-id="element-109" />
    <line x1="41" y1="39" x2="44" y2="37" stroke="#0a2e1f" strokeWidth="1.2" data-id="element-110" />
    {/* Star */}
    <path d="M40 22 L41.5 26.5 L46 26.5 L42.3 29.2 L43.7 33.5 L40 30.8 L36.3 33.5 L37.7 29.2 L34 26.5 L38.5 26.5 Z" fill="#fce38a" stroke="#0a2e1f" strokeWidth="0.8" data-id="element-111" />
  </Frame>;
// B6 — De Club a Pumas: Trophy with arrow up
export const TrophyIcon = () => <Frame data-id="element-112">
    {/* Trophy cup */}
    <path d="M30 26 L50 26 L48 44 Q48 50 40 50 Q32 50 32 44 Z" fill="url(#gold)" stroke="#0a2e1f" strokeWidth="1.5" data-id="element-113" />
    {/* Handles */}
    <path d="M30 30 Q24 30 24 36 Q24 40 30 40" stroke="#d4af37" strokeWidth="2" fill="none" data-id="element-114" />
    <path d="M50 30 Q56 30 56 36 Q56 40 50 40" stroke="#d4af37" strokeWidth="2" fill="none" data-id="element-115" />
    {/* Base */}
    <rect x="35" y="50" width="10" height="3" fill="#d4af37" data-id="element-116" />
    <rect x="30" y="53" width="20" height="4" rx="1" fill="#b5952f" data-id="element-117" />
    {/* Star on cup */}
    <path d="M40 32 L41 34.5 L43.5 34.5 L41.5 36 L42.3 38.5 L40 37 L37.7 38.5 L38.5 36 L36.5 34.5 L39 34.5 Z" fill="#0a2e1f" data-id="element-118" />
  </Frame>;
export const bonusIcons = [CaptainIcon, NotebookIcon, ScoutingIcon, ShieldIcon, RugbyBallIcon, TrophyIcon];